import {POP, PUSH} from "../reducers/message";

export const pop =() => {
    return { type: POP };
};
export const push =(payload) => {
    return { type: PUSH, payload };
};